import React, { useState, useEffect, useRef } from "react";
import { Grid, Typography, IconButton, Paper } from "@material-ui/core";
// import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   Button,
//   Box,
//   Checkbox,
//   TableBody,
//   Typography,
//   TextField,
// } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
// import { Delete } from "@material-ui/icons";
import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import { useSelector } from "react-redux";
import Heading from "../../../../StyledComponents/Heading/Heading";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import getParameterByName from "../../../../Functions/functions";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  // intColumn,
  floatColumn,
  // resizeColumn,
} from "react-datasheet-grid";
const useStyles = makeStyles({
  table: {
    minWidth: 650,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  checkboxContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: "5px 0px",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "left",
    marginRight: "16px",
  },
  checkboxItemFirst: {
    marginLeft: 0,
  },
  "@media only screen and (max-width: 991px)": {
    checkboxContainer: {
      flexDirection: "column",
    },
    checkboxItem: {
      marginBottom: "8px",
      marginRight: 0,
    },
    checkboxItemFirst: {
      marginBottom: "8px",
    },
  },
});

function POTableFor_Model({
  formState,
  formState_v1,
  setSelectedTotal,
  setFormState,
  disabled,
  filter,
  deletee,
  Invoice_id,
  selected_PoRec,
  setSelected_PoRec,
  checkedBox,
  loading,
  edit,
  selectedRole,
  ipUser,
}) {
  const tableData = {
    assetNumber: "",
    balancE_QTY: 0,
    balancE_VAL: 0,
    conD_COUNT: "",
    conD_ST_NO: "",
    currency: "",
    disT_IND: "",
    dN_NO: "",
    doc_Date: "",
    doC_YEAR: "",
    delivUnit: "",
    Dlvqty: "", //
    inpuT_VAL: 0,
    inpuT_QTY: 0,
    invoicE_QTY: 0,
    invoicE_VAL: 0,
    kschl: "",
    ordeR_QTY: "",
    ordeR_UNIT: "",
    poItem: "",
    poItemText: "",
    poNumber: "",
    plant: "",
    uniT_PRICE : "",
    poqty: "", //
    quantity: "",
    refDoc: "",
    reF_DOC_IT: "",
    reF_DOC_NO: "",
    reF_DOC_NO_LONG: "",
    seQ_NO: "",
    sheeT_ITEM: "",
    sheeT_NO: "", //
    sO_ITEM: "",
    sO_NO: "",
    vText: "",
    Val_Gr_Loc: "", //
    Val_Iv_Loc: "", //
    val_Loccur: "",
    Vendor_Code: "", //
    Vendor_Name: "", //
    doc_Date: "",
    invoice_Id: Number(Invoice_id),
    selected: false,
  };
  const classes = useStyles();
  const editable = getParameterByName("edit");
  const [isSelectAll, setIsSelectAll] = useState(false);

  const [cellState, setCellState] = useState("");

  const role = useSelector((state) => state.Role);
  // function to compare selected PO records GRN Amount with Invoice Amount so we can proceed
  const checkBal = (tempArray) => {
    let t = 0;
    if (!ipUser) {
      let totalItems = tempArray.filter((data) => data.selected == true);
      t = totalItems
        .map((balance) =>
          Number(
            balance?.inpuT_VAL?.toFixed(2) || balance?.INPUT_VAL?.toFixed(2)
          )
        )
        .reduce((total, item) => total + item, 0);
    } else if (ipUser) {
      let totalItems = tempArray;
      t = totalItems
        .map((balance) =>
          Number(
            balance?.inpuT_VAL?.toFixed(2) || balance?.INPUT_VAL?.toFixed(2)
          )
        )
        .reduce((total, item) => total + item, 0);
    }

    setSelectedTotal(t);
  };

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: [...formState.invoicePORef_List, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoicePORef_List?.filter(
      (x, i) => i !== index
    );
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: filteredData,
    }));
    checkBal(filteredData);
  };
  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    if (name === "val_Loccur") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(value) - Number(tempArray[index].invoicE_VAL)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_VAL") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(tempArray[index].val_Loccur) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "quantity") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: Number(value) - Number(tempArray[index].invoicE_QTY),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_QTY") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: (
          Number(tempArray[index].quantity) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "inpuT_QTY") {
      let tempArray = formState.invoicePORef_List;
      if (
        value <=
        Number(tempArray[index].quantity) - Number(tempArray[index].invoicE_QTY)
      ) {
        tempArray[index] = {
          ...formState.invoicePORef_List[index],
          [name]: Number(value),
          inpuT_VAL: Number(
            (
              (Number(tempArray[index].val_Loccur) /
                Number(tempArray[index].quantity)) *
              Number(value)
            )?.toFixed(2)
          ),
        };
        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));

        checkBal(tempArray);
      }
    } else if (name === "inpuT_VAL") {
      let tempArray = formState.invoicePORef_List;

      // the below commented code if user not allow to add value more the invoice 5%
      // it works on entered the value, i have also add functionality on input (min, max) so we need this commented code. for now.

      // if (
      //   // value <=
      //   // Number(tempArray[index].val_Loccur) -
      //   // Number(tempArray[index].invoicE_VAL)
      //   value <=
      //   0.05 *
      //   ((Number(tempArray[index].val_Loccur) /
      //     Number(tempArray[index].quantity)) *
      //     Number(tempArray[index].inpuT_QTY)) +
      //   (Number(tempArray[index].val_Loccur) /
      //     Number(tempArray[index].quantity)) *
      //   Number(tempArray[index].inpuT_QTY)
      // ) {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(Number(value)?.toFixed(2)),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };

  useEffect(() => {
    setIsSelectAll(false);
  }, [filter]);

  const selectAll = (e) => {
    let tempArray = formState.invoicePORef_List;
    const tempArray_v1 = formState_v1.invoicePORef_List;
    for (let index = 0; index < formState?.invoicePORef_List?.length; index++) {
      const element = formState?.invoicePORef_List[index];

      const originalPosition = findOrignalPosition(index);
      tempArray_v1[originalPosition].selected = true;

      tempArray[index].selected = e.target.checked;
    }
    const stringify = JSON.stringify(tempArray_v1);
    const parsed = JSON.parse(stringify);
    setFormState({
      ...formState,
      invoicePORef_List: parsed,
    });
    checkBal(parsed);
    setIsSelectAll(e.target.checked);
  };

  const findOrignalPosition = (rowIndex) => {
    let tempArray = formState.invoicePORef_List;
    const selectedRow = tempArray[rowIndex];
    const tempArray_v1 = formState_v1.invoicePORef_List;
    const finded = tempArray_v1.findIndex(
      (x) =>
        x.id === selectedRow?.id &&
        x.POItem === selectedRow?.POItem &&
        x.PONumber === selectedRow?.PONumber &&
        x.RefDoc === selectedRow?.RefDoc &&
        x.DN_NO === selectedRow?.DN_NO
    );
    return finded;
  };
  const handleGridChange = (data, operation) => {
    let rowIndex = cellState?.cell?.row;
    let name = cellState?.cell?.colId;

    let tempArray = data;

    // for consumed quantity
    if (name === "selected") {
      if (tempArray[rowIndex]?.selected === true) {
        tempArray[rowIndex].selected = true;

        const tempArray_v1 = formState_v1.invoicePORef_List;
        const originalPosition = findOrignalPosition(rowIndex);
        tempArray_v1[originalPosition].selected = true;
        const stringify = JSON.stringify(tempArray_v1);
        const parsed = JSON.parse(stringify);

        setFormState({
          ...formState,
          invoicePORef_List: parsed,
        });

        checkBal(tempArray);
      } else {
        let tempArray = formState.invoicePORef_List;
        tempArray[rowIndex].selected = false;

        const tempArray_v1 = formState_v1.invoicePORef_List;
        const originalPosition = findOrignalPosition(rowIndex);
        tempArray_v1[originalPosition].selected = false;
        const stringify = JSON.stringify(tempArray_v1);
        const parsed = JSON.parse(stringify);
        setFormState({
          ...formState,
          invoicePORef_List: parsed,
        });
        checkBal(tempArray_v1);
      }
    } else if (name === "Quantity") {
      //  GRN quantity
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        Quantity: Number(tempArray[rowIndex].Quantity),
        INPUT_QTY:
          Number(tempArray[rowIndex].Quantity) -
          // Number(value).toFixed(0) -
          Number(tempArray[rowIndex].INVOICE_QTY),
        // Number(tempArray[index].INVOICE_QTY).toFixed(0),
      };

      const tempArray_v1 = formState_v1.invoicePORef_List;
      const originalPosition = findOrignalPosition(rowIndex);

      tempArray_v1[originalPosition] = {
        ...formState_v1.invoicePORef_List[originalPosition],
        Quantity: Number(tempArray[rowIndex].Quantity),
        INPUT_QTY:
          Number(tempArray[rowIndex].Quantity) -
          Number(tempArray[rowIndex].INVOICE_QTY),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray_v1,
      }));
      checkBal(tempArray_v1);
    } else if (name === "INVOICE_QTY") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        INVOICE_QTY: Number(tempArray[rowIndex].INVOICE_QTY),
        INPUT_QTY:
          Number(tempArray[rowIndex].Quantity) -
          // Number(tempArray[index].Quantity).toFixed(0) -
          Number(tempArray[rowIndex].INVOICE_QTY),
        // Number(value).toFixed(0),
        // INPUT_VAL:Number(tempArray[index].Val_Loccur) - Number(tempArray[index].Val_Loccur)/Number( tempArray[index].Quantity)*Number(value)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "Val_Loccur") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        Val_Loccur: Number(tempArray[rowIndex].Val_Loccur),
        INPUT_VAL: Number(
          (
            Number(tempArray[rowIndex].Val_Loccur) -
            Number(tempArray[rowIndex].INVOICE_VAL)
          )?.toFixed(2)
        ),
        // INVOICE_VAL: Number(value)/Number( tempArray[index].Quantity)*Number(tempArray[index].INVOICE_QTY)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "INVOICE_VAL") {
      // consumed Amount
      if (
        tempArray[rowIndex].INVOICE_VAL <=
        (Number(tempArray[rowIndex].Val_Loccur) / // GRN amount
          Number(tempArray[rowIndex].Quantity)) * // GRN quantity
          Number(tempArray[rowIndex].INVOICE_QTY) //  consumed quantity
      ) {
        tempArray[rowIndex] = {
          ...formState.invoicePORef_List[rowIndex],
          INVOICE_VAL: Number(tempArray[rowIndex].INVOICE_VAL),
          INPUT_VAL: Number(
            (
              Number(tempArray[rowIndex].Val_Loccur) -
              Number(tempArray[rowIndex].INVOICE_VAL)
            )?.toFixed(2)
          ),
        };

        //  to update the orignal
        const tempArray_v1 = formState_v1.invoicePORef_List;
        const originalPosition = findOrignalPosition(rowIndex);

        tempArray_v1[originalPosition] = {
          ...formState_v1.invoicePORef_List[originalPosition],

          INVOICE_VAL: Number(tempArray[rowIndex].INVOICE_VAL),
          INPUT_VAL: Number(
            (
              Number(tempArray[rowIndex].Val_Loccur) -
              Number(tempArray[rowIndex].INVOICE_VAL)
            )?.toFixed(2)
          ),
        };

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray_v1,
        }));
        checkBal(tempArray_v1);
      }
    } else if (name === "INPUT_QTY") {
      // if (
      //   value <=
      //   Number(tempArray[index].Quantity) - Number(tempArray[index].INVOICE_QTY)
      // ) {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        INPUT_QTY: Number(tempArray[rowIndex].INPUT_QTY),
        INPUT_VAL: Number(
          (
            (Number(tempArray[rowIndex].Val_Loccur) /
              Number(tempArray[rowIndex].Quantity)) *
            Number(tempArray[rowIndex].INPUT_QTY)
          )?.toFixed(2)
        ),
      };

      const tempArray_v1 = formState_v1.invoicePORef_List;
      const originalPosition = findOrignalPosition(rowIndex);

      tempArray_v1[originalPosition] = {
        ...formState_v1.invoicePORef_List[originalPosition],

        INPUT_QTY: Number(tempArray[rowIndex].INPUT_QTY),
        INPUT_VAL: Number(
          (
            (Number(tempArray[rowIndex].Val_Loccur) /
              Number(tempArray[rowIndex].Quantity)) *
            Number(tempArray[rowIndex].INPUT_QTY)
          )?.toFixed(2)
        ),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray_v1,
      }));
      checkBal(tempArray_v1);
      // }
    } else {
      const tempArray_v1 = formState_v1.invoicePORef_List;

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray_v1,
      }));
      checkBal(tempArray_v1);
    }
  };
  // const changeHandler = (e, index) => {
  //   const { name, value } = e.target;
  //   let tempArray = formState.invoicePORef_List;
  //   tempArray[index] = {
  //     ...formState.invoicePORef_List[index],
  //     [name]: value,
  //   };

  //   setFormState((formState) => ({
  //     ...formState,
  //     invoicePORef_List: tempArray,
  //   }));
  //   checkBal(tempArray);
  // };
  const selectRec = (e, index) => {
    if (e.target.checked == true) {
      let tempArray = formState.invoicePORef_List;

      tempArray[index].selected = true;
      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index].selected = false;

      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    }

    // if (e.target.checked == true) {
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: [...selected_PoRec.invoicePORef_List, item],
    //   }));
    // } else {
    //   const filteredData = selected_PoRec?.invoicePORef_List?.filter(
    //     (x) => x !== item
    //   );
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: filteredData,
    //   }));
    // }
  };
  const getFirstNonEmptyKey = (...keys) => {
    for (const key of keys) {
      if (key) return key;
    }
    return "";
  };
  // const AmountCell = React.memo(
  //   ({ active, rowData, setRowData,focus  }) => {
  //     const inputRef = useRef(null);

  //     useEffect(() => {
  //       if (focus) {
  //         inputRef.current?.focus();
  //       } else {
  //         inputRef.current?.blur();
  //       }
  //     }, [focus]);

  //     return (
  //       <TextField
  //       type="number"
  //       // name="amount"
  //       // size="small"
  //       // value={rowData?.amount}
  //       sx={{
  //         "& legend": { display: "none" },
  //         "& fieldset": { top: 0 },
  //       }}
  //       variant="standard"
  //       required
  //       value={rowData}
  //       min={0}
  //       InputProps={{
  //         inputProps: { min: 0, step:"0.01" },
  //         disableUnderline: true,
  //       }}

  //       onChange={(e) => setRowData(e.target.value)}

  //     />
  //     )
  //   }
  // )
  // const intColumn = {
  //   component: AmountCell,
  //   deleteValue: () => '',
  //   disableKeys: true,
  //   keepFocus: true,
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // }
  const [columns, setColumns] = useState([
    {
      ...keyColumn("selected", checkboxColumn),
      title: "",
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: disabled,
    },

    {
      // ...keyColumn((disabled && editable === "true") ? "poItem" : "POItem"  , textColumn),
      // ...keyColumn(("poItem" || "POItem"  )   , textColumn),
      ...keyColumn("POItem", textColumn),
      title: "Item #",
      disabled: true,
      minWidth: 160,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn((disabled || editable === "true") ? "poNumber" : "PONumber"  , textColumn),
      ...keyColumn("PONumber", textColumn),

      title: "PO Number",
      minWidth: 160,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("RefDoc", textColumn),
      ...keyColumn("RefDoc", textColumn),

      title: "GRN No",
      minWidth: 160,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),

      // grow: 2,
    },
    {
      // ...keyColumn("Quantity", textColumn),
      ...keyColumn("Quantity", textColumn),

      title: "GRN Quantity",
      width: 160,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,

      // grow: 2,
    },

    {
      // ...keyColumn("Val_Loccur", textColumn),
      ...keyColumn("Val_Loccur", textColumn),

      title: "GRN Amount",
      width: 160,
      // grow: 4,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INVOICE_QTY", textColumn),
      ...keyColumn("INVOICE_QTY", textColumn),

      title: "Consumed Quantity",
      width: 160,
      // grow: 3,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: disabled,
    },
    {
      // ...keyColumn("INVOICE_VAL", textColumn),
      ...keyColumn("INVOICE_VAL", textColumn),

      title: "Consumed Amount",
      width: 160,
      // grow: 3,
      //   disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INPUT_QTY", textColumn),
      ...keyColumn("INPUT_QTY", floatColumn),

      title: " Invoice Qty",
      width: 160,
      // grow: 2,
      disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: disabled,
    },
      {
      ...keyColumn("uniT_PRICE", textColumn),
      title: "Unit Price",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("INPUT_VAL", textColumn),
      ...keyColumn("INPUT_VAL", floatColumn),

      title: "Invoice Amt",
      minWidth: 160,
      grow: 2,
      disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: disabled,
    },
    {
      // ...keyColumn("Currency", textColumn),
      ...keyColumn("Currency", textColumn),

      title: "Currency",
      // width: 150,
      disabled: true,

      grow: 2,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("POItemText", textColumn),
      ...keyColumn("POItemText", textColumn),

      title: " PO Text",
      disabled: true,
      minWidth: 300,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("Plant", textColumn),
      ...keyColumn("Plant", textColumn),

      title: "Plant",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

   


    {
      // ...keyColumn("DN_NO", textColumn),
      ...keyColumn("DN_NO", textColumn),

      title: "Delivery Note",
      disabled: true,
      minWidth: 140,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("AssetNumber", textColumn),
      ...keyColumn("AssetNumber", textColumn),

      title: "Asset No",
      disabled: true,
      minWidth: 140,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("VText", textColumn),
      ...keyColumn("VText", textColumn),

      title: "Text",
      disabled: true,
      minWidth: 140,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    // will be called to handle pasting. Because we chose to copy the label, we have to transform it back to a value on pasting.
  ]);

  return (
    <Grid container style={{ margin: "30px 0px" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        <Heading title="PO Details" />

        {formState.invoicePORef_List?.length === 0 && !loading ? (
          <EmptyData />
        ) : loading ? (
          <>
            <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
              <LinearProgress color="info" />
              <LinearProgress color="info" />
              <LinearProgress color="info" />
            </Stack>
          </>
        ) : (
          <>
            <div className={classes.checkboxContainer}>
              <input
                type="checkbox"
                checked={isSelectAll}
                onChange={(e) => {
                  selectAll(e);
                }}
                className={classes.checkboxItemFirst}
              />
              <Typography className={classes.checkboxItem}>
                Select All
              </Typography>
            </div>
            <DataSheetGrid
              style={{
                "--dsg-header-text-color": "#031C30",
              }}
              // value={ formState.invoicePORef_List }
              value={[
                ...formState?.invoicePORef_List?.map((item) => {
                  const newItem = { ...item };
                  if (newItem.hasOwnProperty("INPUT_VAL")) {
                    newItem["INPUT_VAL"] = Number(
                      Number(newItem["INPUT_VAL"])?.toFixed(2)
                    );
                    newItem["Currency"]="PKR"
                  } else if (newItem.hasOwnProperty("inpuT_VAL")) {
                    newItem["inpuT_VAL"] = Number(
                      Number(newItem["inpuT_VAL"])?.toFixed(2)
                    );
                    newItem["Currency"]="PKR"
                  }
                  return newItem;
                }),
              ]}
              onChange={handleGridChange}
              columns={columns}
              lockRows={
                disabled || formState.invoicePORef_List.length === 0
                  ? true
                  : false
              }
              //  lockRows={false}

              onActiveCellChange={(res) => {
                setCellState(res);
              }}

              // onDelete={handleDelete}
            />
          </>
        )}

        {/* {!disabled && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button
              color="secondary"
              variant="contained"
              onClick={addInput}
              style={{ display: edit == "false" ? "none" : "" }}
            >
              Add New Row
            </Button>
          </Box>
        )} */}
      </Grid>
    </Grid>
  );
}

export default React.memo(POTableFor_Model);
